// Shipping protection switch (prompt 102, snippets/ssc-protect.liquid). On = the $5 `shipping-protection` product at
// quantity 1; off = removed. Backstops on every cart change: never more than 1, and removed when the cart has nothing
// else in it. The drawer and /cart re-render on the same shopify:cart:lines-update event the bundler and one-per use.
(function () {
  var HANDLE = 'shipping-protection';
  var me = document.currentScript;
  var busy = false;

  function split(cart) {
    var out = { qty: 0, real: 0, id: null };
    (cart.items || []).forEach(function (it) {
      if (it.handle === HANDLE) { out.qty += it.quantity || 0; out.id = it.variant_id; } else if (it.handle !== 'kit-customization') out.real += it.quantity || 0;
    });
    return out;
  }

  function setQty(id, qty) {
    var updates = {};
    updates[id] = qty;
    var req = fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates: updates }) })
      .then(function (r) { if (!r.ok) throw new Error('cart update ' + r.status); return r.json(); });
    var ev = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
    ev.action = 'update';
    ev.promise = req.then(function (cart) { return { detail: { action: 'update', itemCount: split(cart).real } }; });
    document.dispatchEvent(ev);
    return req;
  }

  function check(after) {
    var run = function () {
      if (busy) return;
      fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); }).then(function (cart) {
        var s = split(cart);
        if (!s.id || busy) return;
        var want = s.real > 0 ? Math.min(s.qty, 1) : 0;
        if (want === s.qty) return;
        busy = true;
        setQty(s.id, want).catch(function () {}).then(function () { setTimeout(function () { busy = false; }, 800); });
      }).catch(function () {});
    };
    if (after && typeof after.then === 'function') after.then(run, run); else run();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target instanceof Element ? e.target.closest('[data-ssc-protect]') : null;
    if (!btn || busy) return;
    e.preventDefault();
    var on = btn.getAttribute('aria-checked') !== 'true';
    busy = true;
    btn.setAttribute('aria-checked', String(on));
    btn.setAttribute('aria-busy', 'true');
    setQty(btn.getAttribute('data-ssc-protect'), on ? 1 : 0)
      .catch(function () { btn.setAttribute('aria-checked', String(!on)); })
      .then(function () { btn.removeAttribute('aria-busy'); busy = false; });
  });

  document.addEventListener('shopify:cart:lines-update', function (e) { check(e && e.promise); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) check(); });
  // On load only when the page was rendered with protection in the cart (scripts.liquid sets data-check).
  if (me && me.hasAttribute('data-check')) check();
})();
